import React from 'react';
import { Skeleton, Space } from 'antd';

export const TableSkeleton = ({ 
  columns = 6, 
  rows = 8, 
  hasFilters = false,
  filterCount = 4,
  hasSearch = false 
}) => {
  const colWidths = ['6%', '22%', '18%', '16%', '18%', '20%', '15%'];

  return (
    <div className="table-skeleton-wrap" style={{ width: '100%', marginTop: 16 }}>
      {(hasSearch || hasFilters) && (
        <div style={{ marginBottom: 18, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          {hasSearch && (
            <Space size="middle">
              <Skeleton.Button active style={{ width: 180, height: 36, borderRadius: 6 }} />
              <Skeleton.Input active style={{ width: 240, height: 36, borderRadius: 6 }} />
            </Space>
          )}
          {hasFilters && (
            <Space size="middle" style={{ flexWrap: 'wrap' }}>
              {Array.from({ length: filterCount }).map((_, idx) => (
                <div key={'filt_' + idx} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <Skeleton.Input active size="small" style={{ width: 60, height: 12, borderRadius: 4 }} />
                  <Skeleton.Button active style={{ width: 140, height: 32, borderRadius: 6 }} />
                </div>
              ))}
            </Space>
          )}
        </div>
      )}

      <div
        style={{
          border: '1px solid #f0f0f0',
          borderRadius: 6,
          overflow: 'hidden',
          backgroundColor: '#ffffff'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fafafa',
            borderBottom: '1px solid #f0f0f0',
            padding: '12px 16px',
            gap: 12
          }}
        >
          {Array.from({ length: columns }).map((_, cIdx) => (
            <div key={'th_' + cIdx} style={{ width: colWidths[cIdx % colWidths.length] || '15%' }}>
              <Skeleton.Input
                active
                size="small"
                style={{
                  width: '80%',
                  height: 16,
                  borderRadius: 4
                }}
              />
            </div>
          ))}
        </div>

        {Array.from({ length: rows }).map((_, rIdx) => (
          <div
            key={'tr_' + rIdx}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              borderBottom: rIdx === rows - 1 ? 'none' : '1px solid #f0f0f0',
              backgroundColor: rIdx % 2 === 1 ? '#fafbfc' : '#ffffff',
              gap: 12
            }}
          >
            {Array.from({ length: columns }).map((_, cIdx) => (
              <div key={'td_' + rIdx + '_' + cIdx} style={{ width: colWidths[cIdx % colWidths.length] || '15%' }}>
                {cIdx === 0 ? (
                  <Skeleton.Input active size="small" style={{ width: 28, height: 16, borderRadius: 4 }} />
                ) : cIdx === columns - 1 ? (
                  <Space size="small">
                    <Skeleton.Button active size="small" shape="circle" style={{ width: 24, height: 24 }} />
                    <Skeleton.Button active size="small" shape="circle" style={{ width: 24, height: 24 }} />
                  </Space>
                ) : cIdx % 3 === 0 ? (
                  <Skeleton.Button active size="small" style={{ width: 90, height: 22, borderRadius: 12 }} />
                ) : (
                  <Skeleton.Input
                    active
                    size="small"
                    style={{
                      width: '' + (65 + ((rIdx * 7 + cIdx * 13) % 30)) + '%',
                      height: 16,
                      borderRadius: 4
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 8 }}>
        <Skeleton.Button active size="small" style={{ width: 32, height: 32, borderRadius: 4 }} />
        <Skeleton.Button active size="small" style={{ width: 32, height: 32, borderRadius: 4 }} />
        <Skeleton.Button active size="small" style={{ width: 32, height: 32, borderRadius: 4 }} />
      </div>
    </div>
  );
};

export default TableSkeleton;
